<template>
	<svg
		width="54px"
		height="44px"
		viewBox="0 0 54 44"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="camera off icon"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g
				transform="translate(-624.000000, -430.000000)"
				:fill="color"
				fill-rule="nonzero"
			>
				<g transform="translate(532.000000, 206.000000)">
					<g transform="translate(50.000000, 16.000000)">
						<g transform="translate(0.000000, 15.000000)">
							<g transform="translate(6.000000, 0.000000)">
								<g transform="translate(7.000000, 175.000000)">
									<g transform="translate(18.000000, 18.000000)">
										<path
											d="M54.1669922,43.5527344 C54.7900391,42.9296875 54.7900391,41.9199219 54.1669922,41.296875 L14.1201172,1.27148438 C13.4970703,0.6484375 12.4658203,0.626953125 11.8427734,1.27148438 C11.2412109,1.87304688 11.2412109,2.90429688 11.8427734,3.50585938 L51.9326172,43.5527344 C52.5556641,44.1757813 53.5654297,44.1757813 54.1669922,43.5527344 Z M49.3330078,33.0253906 C49.4619141,32.359375 49.5478516,31.4785156 49.5478516,30.6621094 L49.5478516,12.2714844 C49.5478516,8.125 47.2705078,5.74023438 43.0810547,5.74023438 L22.0478516,5.74023438 L49.3330078,33.0253906 Z M61.9873047,35.8183594 C63.5771484,35.8183594 64.6513672,34.6582031 64.6513672,32.9609375 L64.6513672,11.7128906 C64.6513672,10.015625 63.5771484,8.85546875 61.9873047,8.85546875 C61.1923828,8.85546875 60.3759766,9.26367188 59.6240234,9.90820313 L52.3837891,16.1601563 L52.3837891,28.5136719 L59.6240234,34.765625 C60.3759766,35.4101563 61.1923828,35.8183594 61.9873047,35.8183594 Z M43.8115234,38.9121094 L14.9365234,10.0371094 C14.7216797,10.5527344 14.5712891,11.4765625 14.5712891,12.3574219 L14.5712891,32.359375 C14.5712891,36.5058594 17.0205078,38.9121094 21.2099609,38.9121094 L43.8115234,38.9121094 Z"
										></path>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'CameraOff',
	props: {
		color: {
			type: String,
			default: '#C7CACE',
		},
	},
}
</script>

<style lang="scss" scoped></style>
